var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0C8.95,0,0,8.95,0,20s8.95,20,20,20,20-8.95,20-20S31.05,0,20,0Zm1.5,29.5h-3v-12h3v12Zm-.33-16.15c-.32,.3-.71,.45-1.17,.45s-.86-.15-1.17-.45c-.32-.3-.48-.68-.48-1.15s.16-.87,.48-1.2,.71-.5,1.17-.5,.86,.17,1.17,.5c.32,.33,.48,.73,.48,1.2s-.16,.85-.48,1.15Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.963830039c41d55f94cd31eb5a59d096.svg";
export { ForwardRef as ReactComponent };